
import moment from 'moment'
import common from '@/libs/common.mixin'
import wxjssdk from '@/libs/wxjssdk.mixin'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Rater from 'vux/src/components/rater/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Divider from 'vux/src/components/divider/index.vue'

export default{
mixins: [common,wxjssdk],
components: {
Card,
Popup,
Rater,
Group,
XButton,
Divider,
Flexbox,
LoadMore,
XTextarea,
FlexboxItem
},
data () {
return {
employee: {},
popup_comment: false,
params: {
review_type: 4,
review_content: '',
score1: 0,
eid: 0,
},
data_uri: 'open/teacher_reviews?eid='+this.$route.params.id,
data: [],
total: 0
}
},
mounted () {
this.init_data()
},
methods: {
formatDate (val){
return moment(val).format('YYYY-MM-DD')
},
setShare () {
let employee = this.employee
let [title,img,desc,link] = ['','','这个人很懒，还没有写个人签名','']
if(employee){
title = employee.ename
img = employee.photo_url || 'http://s1.xiao360.com/common_img/avatar.jpg'
if(employee.profile){desc = employee.profile.sign}
link = window.location.href
}
this.setWxShare(title,img,desc,link)
},
init_data () {
this.$http.post('share/employee?eid='+this.$route.params.id)
.then(response=>{
this.employee = response.body.data

this.setShare()
}).catch(response=>{
this.toast(response.body.message,'text')
})
},










cancel_comment () {
this.params.review_content = ''
this.params.score1 = 0
this.popup_comment = false
},
submit_comment () {
this.params.eid = this.employee.eid
this.$http.post('reviews',this.params)
.then(response=>{
this.toast('评论成功','success')
this.init_data()
setTimeout(()=>{
this.cancel_comment()
},800)
}).catch(response=>{
this.toast(response.body.message,'text')
})
}
},
computed: {
required () {
return this.params.review_content.length === 0 || this.params.score1===0
},
backgroundImage () {
let [profile,img] = [this.employee.profile,'/static/hadmin/img/p_big3.jpg']
if(profile&&profile.background_img) {
img = profile.background_img
}
return img
}
}
}



// WEBPACK FOOTER //
// ./src/views/public/teacher-introduce.vue